import React, { FC } from 'react';
import { Descriptions } from 'antd';
import Actions from '../Actions/Actions';
import { connect } from 'react-redux';
import {
  moveToPreviousPage,
  AnnotationStandardDetails,
  FindingTypeTemplateDetails,
  finishAnnotationStandardForm,
  clearFinished,
  FindingTypeDetails
} from '../AnnotationStandardForm.slice';
import { AppDispatch } from '../../../../store';
import { RootState } from '../../../../rootReducer';
import styles from './Finish.module.scss';
import rootStyles from '../AnnotationStandardForm.module.scss';
import { Redirect } from 'react-router-dom';
import { FailureMechanismTemplate } from '../../FailureMechanismTemplate/failureMechanismTemplate.slice';
import { FailureModeCategoryTemplate } from '../../FailureModeCategoryTemplate/failureModeCategoryTemplate.slice';
import { EightDTemplate } from '../../EightDTemplate/eightDTemplate.slice';

type Props = {
  selectedFindingTypes: Array<FindingTypeTemplateDetails>;
  annotationStandard: AnnotationStandardDetails;
  isLoading: boolean;
  finished: boolean;
  failureMechanismTemplates: FailureMechanismTemplate[];
  failureModeCategoryTemplates: FailureModeCategoryTemplate[];
  eightDTemplates: EightDTemplate[];
  onMoveToPreviousPage: () => void;
  onDoneClicked: () => void;
  onClearFinished: () => void;
};

const Finish: FC<Props> = ({
  selectedFindingTypes,
  annotationStandard,
  isLoading,
  onMoveToPreviousPage,
  onDoneClicked,
  finished,
  onClearFinished,
  failureMechanismTemplates,
  failureModeCategoryTemplates,
  eightDTemplates
}) => {
  const onPreviousPage = () => {
    onMoveToPreviousPage();
  };

  const getFindingTypeTemplate = (id: string) => {
    return selectedFindingTypes.find(x => x.id === id)!;
  };

  const getFindingTypePropertyTemplate = (typeId: string, id: string) => {
    const findingTypeProperty = selectedFindingTypes.find(x => x.id === typeId)!.properties.find(x => x.id === id);
    return findingTypeProperty;
  };

  function prepareFailureMechanismTemplateNames(
    findingType: FindingTypeDetails,
    failureMechanismTemplates: FailureMechanismTemplate[]
  ): React.ReactNode {
    if (!findingType.failureMechanismTemplateIds.length) {
      return 'Nothing selected.';
    }

    const notDeprecatedNames = findingType.failureMechanismTemplateIds
      .map(id => {
        var template = failureMechanismTemplates.find(x => x.id === id);
        return template?.name;
      })
      .filter(x => !!x);

    if (!notDeprecatedNames.length) {
      return 'Nothing selected.';
    }

    return notDeprecatedNames.join(', ');
  }

  if (finished) {
    onClearFinished();
    return <Redirect to='/annotation-manager/annotation-standards' />;
  }

  function prepareFailureModeTemplateNames(
    findingType: FindingTypeDetails,
    failureModeCategoryTemplates: FailureModeCategoryTemplate[]
  ): React.ReactNode {
    if (!findingType.failureModeCategoryTemplateIds.length) {
      return 'Nothing selected.';
    }

    const notDeprecatedNames = findingType.failureModeCategoryTemplateIds
      .map(id => {
        var template = failureModeCategoryTemplates.find(x => x.id === id);
        return template?.name;
      })
      .filter(x => !!x);

    if (!notDeprecatedNames.length) {
      return 'Nothing selected.';
    }

    return notDeprecatedNames.join(', ');
  }

  function prepareEightDTemplateNames(findingType: FindingTypeDetails, eightDTemplates: EightDTemplate[]): React.ReactNode {
    if (!findingType.eightDTemplateIds?.length) {
      return 'Nothing selected.';
    }

    const notDeprecatedCodes = findingType.eightDTemplateIds
      .map(id => {
        var template = eightDTemplates.find(x => x.id === id);
        return template?.code;
      })
      .filter(x => !!x);

    if (!notDeprecatedCodes.length) {
      return 'Nothing selected.';
    }

    return notDeprecatedCodes.join(', ');
  }
  return (
    <div>
      <div className={rootStyles.contentContainer}>
        <Descriptions bordered title='Review annotation standard' column={1}>
          <Descriptions.Item className={styles.descriptionItem} label='Annotadion standard name'>
            {annotationStandard.name}
          </Descriptions.Item>
          <Descriptions.Item label='Annotadion standard body'>{annotationStandard.standardBody}</Descriptions.Item>
          <Descriptions.Item label='Annotadion standard version'>{annotationStandard.version}</Descriptions.Item>
          <Descriptions.Item label='Annotadion standard released'>{annotationStandard.released ? 'Yes' : 'No'}</Descriptions.Item>
          <Descriptions.Item label='Annotadion standard depricated'>{annotationStandard.deprecated ? 'Yes' : 'No'}</Descriptions.Item>
          <Descriptions.Item label='Annotadion standard description'>{annotationStandard.description}</Descriptions.Item>
        </Descriptions>
        <Descriptions bordered title='Finding types' column={1} style={{ marginTop: '1rem' }}>
          {annotationStandard.findingTypes.map(findingType => (
            <Descriptions.Item key={findingType.findingTypeTemplateId} label={getFindingTypeTemplate(findingType.findingTypeTemplateId).name}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span>
                  <span style={{ fontWeight: 'bold' }}>Selected Failure Mechanisms: </span>
                  {prepareFailureMechanismTemplateNames(findingType, failureMechanismTemplates)}
                </span>
                <span>
                  <span style={{ fontWeight: 'bold' }}> Selected Failure Modes: </span>
                  {prepareFailureModeTemplateNames(findingType, failureModeCategoryTemplates)}
                </span>
                <span>
                  <span style={{ fontWeight: 'bold' }}> Selected 8D: </span>
                  {prepareEightDTemplateNames(findingType, eightDTemplates)}
                </span>
              </div>
              <table className='custom-table'>
                <thead>
                  <tr>
                    <th>Property Name</th>
                    <th>Title</th>
                    <th>Unit</th>
                    <th>Group</th>
                    <th>Mandatory</th>
                  </tr>
                </thead>
                <tbody>
                  {findingType.representations.map(representation => (
                    <tr key={representation.findingTypePropertyId}>
                      <td>{getFindingTypePropertyTemplate(findingType.findingTypeTemplateId, representation.findingTypePropertyId)?.name}</td>
                      <td>{representation.title}</td>
                      <td>{representation.unit}</td>
                      <td>{representation.group}</td>
                      <td>{representation.isMandatory ? 'Yes' : 'No'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Descriptions.Item>
          ))}
        </Descriptions>
        <Descriptions bordered title='Rules' column={1} style={{ marginTop: '1rem' }}>
          {selectedFindingTypes.some(x => x.properties.some(y => y.values !== '')) ? (
            annotationStandard.findingTypes.map(findingType => (
              <Descriptions.Item key={findingType.findingTypeTemplateId} label={getFindingTypeTemplate(findingType.findingTypeTemplateId).name}>
                <table className='custom-table'>
                  <thead>
                    <tr>
                      {getFindingTypeTemplate(findingType.findingTypeTemplateId).properties.map(prop =>
                        findingType.rules.some(rule => rule.items.some(item => item.findingTypePropertyId === prop.id && item.value !== '')) ? (
                          <th key={prop.id}>{prop.name}</th>
                        ) : null
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {findingType.rules.map((rule, index) => (
                      <tr key={index}>
                        {getFindingTypeTemplate(findingType.findingTypeTemplateId).properties.map(prop =>
                          rule.items?.find(x => x.findingTypePropertyId === prop.id && x.value !== '') ? (
                            <td key={prop.id}> {rule.items.find(x => x.findingTypePropertyId === prop.id)!.value}</td>
                          ) : null
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Descriptions.Item>
            ))
          ) : (
            <div style={{ textAlign: 'center', marginTop: '35%' }}>There is no finding type properties with predifined values</div>
          )}
        </Descriptions>
      </div>
      <Actions isDisabled={isLoading} onPrevious={onPreviousPage} onDone={onDoneClicked} isLoading={isLoading} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  annotationStandard: state.annotationStandardForm.annotationStandard,
  selectedFindingTypes: state.annotationStandardForm.selectedFindingTypeTemplates,
  isLoading: state.annotationStandardForm.isLoading,
  finished: state.annotationStandardForm.done,
  failureMechanismTemplates: state.annotationStandardForm.failureMechanismTemplates,
  failureModeCategoryTemplates: state.annotationStandardForm.failureModeCategoryTemplates,
  eightDTemplates: state.annotationStandardForm.eightDTemplates
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onMoveToPreviousPage: () => dispatch(moveToPreviousPage()),
  onDoneClicked: () => dispatch(finishAnnotationStandardForm()),
  onClearFinished: () => dispatch(clearFinished())
});

export default connect(mapStateToProps, mapDispatchToProps)(Finish);
